module.exports = __webpack_public_path__ + "static/media/modul_termometr.43d5979b.png";